// Values must stay in sync with the backend SwapPeriodType enum
// (Airlines.Data.Models.TradeBoard.Settings.SwapPeriodType).
// A null selection on the rule set means the "Restrict swap period" rule is off.
export const SwapPeriodType = Object.freeze({
    SameDay: 1,
    SameWeek: 2,
    SamePayPeriod: 3,
    SameSchedulePeriod: 4,
});
